<!--
 * @Description
-->

<template>
  <div class="button-list" :style="{ 'z-index': zIndex }">
    <el-tooltip content="消息列表" placement="left">
      <ElBadge :value="unreadMsgNum" :max="99" class="badge" :hidden="!unreadMsgNum">
        <div class="message item" @click="openContact">
          <IconSvg name="iconxingzhuang" class="fn-16 item-icon"/>
        </div>
      </ElBadge>

    </el-tooltip>
    <el-tooltip content="联系客服" placement="left">
      <div class="service item" @click="contactQrcode">
        <IconSvg name="iconkefu" class="fn-16 item-icon"/>
      </div>
    </el-tooltip>
    <el-popover placement="left" trigger="hover" popper-class="code-popup">
      <div class="code-box">
        <img src="https://pms.locxx.com/static/img/download_app_qrcode.a6462b78.jpg" class="code"/>
        <div class="tips">下载APP随时随地看商机</div>
      </div>
      <div slot="reference" class="appcode item">
        <IconSvg name="iconshouji" class="fn-16 item-icon"/>
      </div>
    </el-popover>
    <el-popover placement="left" trigger="hover" popper-class="code-popup">
      <div class="code-box">
        <img src="@/assets/images/wechat-code.png" class="code"/>
        <div class="tips">关注公众号接收消息不错过</div>
      </div>
      <div slot="reference" class="wxcode item">
        <IconSvg name="iconerweima1" class="fn-16 item-icon"/>
      </div>
    </el-popover>
  </div>
</template>

<script>

import eventLib from '@/common/utils/document-event';
import { getCookie, getStorage } from '@lhb/cache';
import IMUnreadMsgNumMixin from 'src/common/components/Bussiness/IM/IMUnreadMsgNumMixin.js';
import IconSvg from 'src/common/components/Iconfont/IconSvg.vue';

export default {
  name: 'FloatButton',
  components: {
    IconSvg,
  },
  mixins: [IMUnreadMsgNumMixin],
  props: {
    // 悬浮层级
    zIndex: {
      type: Number,
      default: 100
    }
  },

  data() {
    return {
      url: process.env.IM_URL,
    };
  },

  methods: {
    contactQrcode() {
      const token = getCookie('newPmsToken') || getStorage('newPmsToken');
      eventLib.dispatch('OPEN_MICROIM', `${this.url}/#/home?source=pms&token=${token}&consultation_type=6&timestamp=${Math.random()}&mode=pc`);
      window.LHBbigdata.send({
        event_id: '44e0c45c-bf92-4e58-ac62-ef6d565309ae',
      });
    },
    openContact() {
      window.LHBbigdata.send({
        event_id: 'ddd13052-26e3-4080-a8d3-c4e0cb4f2f00',
      });
      const token = getCookie('newPmsToken') || getStorage('newPmsToken');
      eventLib.dispatch('OPEN_MICROIM', `${this.url}/#/home?source=pms&token=${token}&contact_id=''&timestamp=${Math.random()}&mode=pc`);
    }
  },
};
</script>

<style lang="less" scoped>
.button-list {
  width: 42px;
  position: fixed;
  bottom: 48px;
  right: 60px;
  display: flex;
  flex-direction: column;
  background: #F7FBFE;
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.06);
  border-radius: 21px;
  border: 1px solid #E2ECFF;
  .badge {
    /deep/.el-badge__content.is-fixed{
      top: 12px;
      right: 16px;
    }
  }
  .item {
    padding: 8px 11px;
    cursor: pointer;
    &-icon {
      color: #027BFF;
    }
  }
  .item:hover {
    .item-icon {
      color: #FFFFFF;
    }
    background: #006AFF;
  }
  .message {
    border-radius: 21px 21px 0 0;
    padding-top: 16px;
  }
  .wxcode {
    border-radius:  0 0 21px 21px;
    padding-bottom: 14px;
  }
}

.code-popup {
  .code-box {
    display: flex;
    align-items: center;
    flex-direction: column;
    .code {
      width: 88px;
      height: 88px;
      border-radius: 4px;
      border: 4px solid #F6F7F9;
    }
    .tips {
      font-size: 8px;
      font-weight: 400;
      color: #666666;
      line-height: 12px;
    }
  }
}
</style>

<style lang="less">
.el-popover {
  min-width: 0 !important;
}
</style>
